import { useIntegrationsView } from '@futrli/views/hooks/useIntegrationsView';

export const useIntegrations = () => {
  return useIntegrationsView(false).integrations ?? null;
};
